import {memo, useContext} from 'react'

import PropTypes from 'prop-types'

import Context from '@s-ui/react-context'
import SharedCardsCarousel from '@adv-mt/mt-shared-cards-carousel'
import {Headline1} from '@adv-mt/ui/typography'

import {BASE_CLASS, newsItemShape} from './config.js'
import NewsCard from './NewsCard.js'

const News = ({newsFeed}) => {
  const {i18n} = useContext(Context)

  const items = newsFeed?.items ?? []

  if (!items.length) return null

  return (
    <section className={BASE_CLASS}>
      <SharedCardsCarousel titleNode={<Headline1 as="h2">{i18n.t('COMMON.NEWS_ABOUT')}</Headline1>}>
        {items.map(item => (
          <NewsCard key={item.id} item={item} />
        ))}
      </SharedCardsCarousel>
    </section>
  )
}

News.displayName = 'News'
News.propTypes = {
  newsFeed: PropTypes.shape({
    items: PropTypes.arrayOf(newsItemShape)
  })
}

export default memo(News)
